import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Confirm } from "semantic-ui-react";
// import { handleDeleteWiki } from "../../store/actions/wikiActions";
import EditWikiModal from "./EditWikiModal";

const WikiDocList = (props) => {
  const [deleteId, setdeleteId] = useState(null);
  const [editWiki, setEditWiki] = useState(null);
  const [advocate, setAdvocate] = useState(null);
  const dispatch = useDispatch();
  const deleteWiki = () => {
    const athleteId = props.documents[0].forAdvocate
      ? props.documents[0].wikiAdvocate
      : props.documents[0].wikiAthlete;
    const wikis = [
      ...props.documents.map((v) => v.id).filter((a) => a !== deleteId),
    ];

    // dispatch(handleDeleteWiki(deleteId, wikis, athleteId));
  };
  const handleEdit = (document) => {
    let advocate = null;
    if (document?.wikiAdvocate && props.wiki.advocates?.length > 0) {
      props.wiki.advocates.forEach((ele) => {
        if (ele.id === document?.wikiAdvocate) {
          advocate = ele;
        }
      });
    }
    setEditWiki(document);
    setAdvocate(advocate);
  };
  return (
    <>
      <ul>
        {props.documents &&
          props.documents.length > 0 &&
          props.documents.map((document) => {
            return (
              <li key={document?.id}>
                <div className="eventVisitorFull">
                  <div className="two">
                    <a href={document?.file} rel="noreferrer" target="_blank">
                      <p>{document?.fileName}</p>
                    </a>
                  </div>
                  <div className="three">
                    <Button
                      icon="pencil"
                      circular
                      basic
                      size="mini"
                      color="grey"
                      onClick={() => handleEdit(document)}
                    />
                    <Button
                      icon="close"
                      circular
                      basic
                      size="mini"
                      color="red"
                      onClick={() => setdeleteId(document?.id)}
                    />
                  </div>
                </div>
              </li>
            );
          })}
      </ul>
      <Confirm
        open={deleteId}
        content="You Sure Want To Delete ?"
        onCancel={() => {
          setdeleteId(null);
        }}
        onConfirm={() => {
          deleteWiki();
          setdeleteId(null);
        }}
      />
      <EditWikiModal
        open={editWiki}
        close={() => setEditWiki(null)}
        advocate={advocate}
      />
    </>
  );
};

export default WikiDocList;
